// extracted by mini-css-extract-plugin
export default {"layout":"e86bf1b60e _80b48d8425 _0754d330d8","h_slide":"_4066a9ff2f","category":"b3f14d94d8 _8ca2cdf5ac _03998bd7cd"};